import { CrossSectionCanvas } from '@pages/cross-section/shared/CrossSectionCanvas';
import Konva from 'konva';


function drawPipe(opts: {
    id: string,
    pipe: any,
    visible: boolean,
    csCanvas: CrossSectionCanvas,
    onClickCallback: (pipe: ICrossSectionVertex, x: number, y: number) => void
}) {
    let { id, pipe, visible, csCanvas, onClickCallback } = opts;

    let point = pipe.point;
    let x = csCanvas.metersToScreenCoordsX(point.x);
    let y = csCanvas.metersToScreenCoordsY(point.y);
    let r = 5;
    let y_offset = 0;


    if (x > csCanvas.width - csCanvas.canvasOptions.side_margin / 2 || x < csCanvas.canvasOptions.side_margin / 2) {
        visible = false;
    }
    if (y < csCanvas.canvasOptions.top_margin || y > csCanvas.height - csCanvas.canvasOptions.bottom_margin) {
        visible = false;
    }

    let elevType = pipe.props["elevType"];
    let pipeNetType = pipe.props["pipeNetType"];

    if (isNumber(pipe.props["diameter"])) {
        r = (parseFloat(pipe.props["diameter"]) * csCanvas.canvasOptions.x_scale) / 2;
    }
    let thickness = 0;
    if (isNumber(pipe.props["thickness"])) {
        thickness = parseFloat(pipe.props["thickness"]) * csCanvas.canvasOptions.y_scale;
    }

    if (elevType) {
        if ("laki" === elevType || "crown level" === elevType) {
            y_offset = 2 * r + thickness;
        }
    } else if (pipeNetType) {
        if ("water" === pipeNetType) {
            y_offset = 2 * r + thickness;
        }
    }

    let pipeCircle = new Konva.Circle({
        visible: visible,
        name: 'model_' + point.id,
        x: x,
        y: y - r + y_offset,
        stroke: getRgb(point.color),
        radius: r
    });

    pipeCircle.on('click tap', () => {
        onClickCallback(pipe, x, y);
        showTooltip(pipe, x, y, r, y_offset, true, csCanvas);
    });

    pipeCircle.on('mouseover', function () {
        showTooltip(pipe, x, y, r, y_offset, false, csCanvas);
    });

    pipeCircle.on('mouseout', csCanvas.clearHoverTooltips);

    // outer edge of the pipe.
    if (thickness > 0) {
        r = r + thickness;
        y_offset += thickness;
        let outerPipeCircle = new Konva.Circle({
            visible: visible,
            name: 'model_' + point.id,
            x: x,
            y: y - r + y_offset,
            stroke: getRgb(point.color),
            radius: r
        });
        csCanvas.contentLayer.add(outerPipeCircle);
    }

    csCanvas.contentLayer.add(pipeCircle);

    return [pipeCircle];
}



const showTooltip = (pipe: any, x: number, y: number, r: number, y_offset: number, showProps: boolean, csCanvas: CrossSectionCanvas) => {
    let size = r * 2 + 4;
    let t: string[] = [
        pipe.name,
        kuura.getMessage('js.cross_section.b') + ': ' + (pipe.point.x).toFixed(2),
        kuura.getMessage('js.cross_section.z') + ': ' + (pipe.point.y).toFixed(2)
    ].filter(Boolean);

    if (showProps) {
        if (Object.keys(t).length > 0) {
            t.push("\n");
        }
        Object.entries(pipe.props).forEach(([key, val]) => {
            t.push(key + ": " + val);
        })
    }

    let bbRect = new Konva.Rect({
        x: x - (size - 1) / 2,
        y: y - (size - 1) / 2 - r + y_offset,
        width: size,
        height: size,
        stroke: 'gray',
        strokeWidth: 1,
        listening: false
    });

    csCanvas.tooltipLayer.add(bbRect);
    csCanvas.drawTooltip(x, y - 4 - r * 2 + y_offset - 10, t.join('\n'), !!showProps);
    csCanvas.drawSnapCursor(true, x, y - r + y_offset);
}

const getRgb = (color: string) => 'rgb(' + color + ')'

const isNumber = (n: any) => !isNaN(parseFloat(n)) && isFinite(n);

export const CrossSectionPipe = {
    drawPipe
}
